/**
 * Keeps the variant picker's selection pill on the size the shopper actually chose.
 *
 * The black pill behind the selected variant button is positioned by CSS rules that read
 * `data-current-checked` / `data-previous-checked` (see assets/base.css, the
 * `--pill-offset` and wrap-around rules). The button's white text, however, follows the
 * radio's real `:checked` state.
 *
 * When the product section re-renders after a variant change, assets/morph.js restores the
 * PREVIOUS values of those two attributes, so they end up pointing at the old selection
 * while `:checked` points at the new one. The result is a selected button with white text
 * and no pill behind it - a blank, unreadable button - and no button appearing selected.
 *
 * This re-points those attributes at whichever radio is genuinely checked, leaving
 * morph.js untouched.
 */
(function () {
  var PICKER = 'fieldset.variant-option';
  var RADIO = 'input[type="radio"][data-current-checked]';

  function syncGroup(fieldset) {
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll(RADIO));
    if (!inputs.length) return;

    var checked = null;
    var flagged = null;
    inputs.forEach(function (input) {
      if (input.checked) checked = input;
      if (input.getAttribute('data-current-checked') === 'true') flagged = input;
    });

    // Already consistent. This early return is also what stops the MutationObserver
    // below from re-triggering itself on the attributes we set.
    if (!checked || flagged === checked) return;

    inputs.forEach(function (input) {
      input.setAttribute('data-previous-checked', String(input === flagged));
      input.setAttribute('data-current-checked', String(input === checked));
    });

    var label = checked.closest('.variant-option__button-label');
    if (label) {
      var width = Math.round(label.getBoundingClientRect().width);
      if (width) fieldset.style.setProperty('--pill-width-current', width + 'px');
    }
  }

  function sync() {
    document.querySelectorAll(PICKER).forEach(syncGroup);
  }

  // Run straight away, then once more on the next tick: morph replaces the picker
  // asynchronously after the section re-renders, so the second pass catches that.
  // requestAnimationFrame is deliberately avoided - it is throttled in background tabs,
  // which would leave the picker mismatched until the tab regains focus.
  function schedule() {
    sync();
    setTimeout(sync, 0);
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('input[type="radio"]')) schedule();
    },
    true
  );

  new MutationObserver(sync).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-current-checked', 'data-previous-checked'],
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
